export interface RuntimeConfig {
  readonly apiUrl: string;
  readonly cognitoUserPoolId: string;
  readonly cognitoUserPoolClientId: string;
  readonly cognitoRegion: string;
}

let cached: RuntimeConfig | null = null;

export const loadRuntimeConfig = async (): Promise<RuntimeConfig> => {
  if (cached) return cached;
  const response = await fetch("/config.json", { cache: "no-store" });
  if (!response.ok) throw new Error("Missing runtime config.json");
  cached = (await response.json()) as RuntimeConfig;
  return cached;
};
